import { render, staticRenderFns } from "./ConfigRoleFilter.vue?vue&type=template&id=7f1ffe7c&scoped=true"
import script from "./ConfigRoleFilter.vue?vue&type=script&lang=js"
export * from "./ConfigRoleFilter.vue?vue&type=script&lang=js"
import style0 from "./ConfigRoleFilter.vue?vue&type=style&index=0&id=7f1ffe7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1ffe7c",
  null
  
)

export default component.exports